import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Page, Tabs } from '@dixa/lib-shared-habla';
import { useCallback, useState } from 'react';
import { AudioMessageFiles } from './components/audioMessageFiles/audioMessageFiles';
import { WaitMusicFiles } from './components/waitMusicFiles/waitMusicFiles';
export const SettingsAudioView = () => {
    const [activeTab, setActiveTab] = useState('announcement');
    const handleTabChange = useCallback((tab) => {
        setActiveTab(tab);
    }, []);
    return (_jsxs(Page, { children: [_jsx(Page.Head, { title: "Audio files" }), _jsx(Page.Tabs, { children: _jsx(Tabs, { selectedId: activeTab, tabs: [
                        { id: 'announcement', label: 'Announcement' },
                        { id: 'wait-music', label: 'Wait music' },
                    ], onChange: handleTabChange }) }), _jsxs(Page.Body, { children: [activeTab === 'announcement' && _jsx(AudioMessageFiles, {}), activeTab === 'wait-music' && _jsx(WaitMusicFiles, {})] })] }));
};
